import { render, staticRenderFns } from "./FormCard.vue?vue&type=template&id=1166dfc7&scoped=true&"
import script from "./FormCard.vue?vue&type=script&lang=js&"
export * from "./FormCard.vue?vue&type=script&lang=js&"
import style0 from "./FormCard.vue?vue&type=style&index=0&id=1166dfc7&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1166dfc7",
  null
  
)

export default component.exports